import { lazyCreateNewOfficeDoc } from 'owa-office-apps-actions';
import type { OfficeOnlineApp } from 'owa-file/lib/types/OfficeOnlineApp';
import type { MailboxInfo } from 'owa-client-types';

export function handleOfficeAppClick(app: OfficeOnlineApp, mailboxInfo: MailboxInfo) {
    lazyCreateNewOfficeDoc.importAndExecute(app, mailboxInfo);
}
